<template>
  <div
    class="slider-wrapper"
  >
    <v-slide-y-reverse-transition>
      <v-card
        id="mapSlider"
        ref="sliderCard"
        elevation="6"
      >
        <v-card-text>
          <v-container
            class="pa-0"
          >
            <v-row
              dense
              no-gutters
            >
              <v-col
                class="d-flex align-center"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      color="blue darken-3"
                      small
                      dark
                      depressed
                      fab
                      v-bind="attrs"
                      v-on="on"
                      @click="centerSimulacion"
                    >
                      <v-icon
                        medium
                      >
                        mdi-image-filter-center-focus
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Centrar simulación</span>
                </v-tooltip>

                <span
                  id="timer"
                  class="font-weight-light black--text"
                  style="white-space: nowrap;"
                >
                  <span
                    class="mx-1"
                  >
                    {{ timeString }}
                  </span>
                  <span
                    id="fecha"
                    class="mx-0"
                  >
                    {{ dateString }}
                  </span>
                  <span
                    v-show="superficie && simulacion.simulacion.TIPO === 'INCENDIO'"
                    id="superficie"
                    class="mx-2"
                  >
                    {{ superficie }} ha
                  </span>
                </span>
              </v-col>

              <v-col
                class="d-flex justify-end align-center"
                cols="auto"
              >
                <v-tooltip
                  bottom
                />
              </v-col>

              <v-col
                align="right"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      v-show="simulacion.simulacion.VIENTOS"
                      color="blue darken-3"
                      small
                      dark
                      depressed
                      fab
                      v-bind="attrs"
                      style="margin-left: 0.5rem;"
                      v-on="on"
                      @click="changeVientosColours"
                    >
                      <v-icon
                        medium
                      >
                        mdi-invert-colors
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{ modoVientoText }}
                  </span>
                </v-tooltip>

                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      v-show="simulacion.simulacion.VIENTOS && simulacion.simulacion.TIPO === 'INCENDIO'"
                      color="blue darken-3"
                      small
                      dark
                      depressed
                      fab
                      v-bind="attrs"
                      style="margin-left: 0.5rem;"
                      v-on="on"
                      @click="vientosSwitch = !vientosSwitch"
                    >
                      <v-icon
                        medium
                      >
                        mdi-weather-windy
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{ vientosSwitch ? 'Desactivar vientos' : 'Activar vientos' }}
                  </span>
                </v-tooltip>

                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      v-show="isMap3D && simulacion.simulacion.VIENTOS"
                      color="blue darken-3"
                      :disabled="isPlaying"
                      small
                      dark
                      depressed
                      fab
                      v-bind="attrs"
                      style="margin-left: 0.5rem;"
                      v-on="on"
                      @click="flechasSwitch = !flechasSwitch"
                    >
                      <v-icon
                        medium
                      >
                        {{ flechasSwitch ? 'mdi-video-3d-off' : 'mdi-video-3d' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{ flechasSwitch ? 'Desactivar vientos 3D' : 'Activar vientos 3D' }}
                  </span>
                </v-tooltip>

                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      color="blue darken-3"
                      small
                      dark
                      depressed
                      fab
                      v-bind="attrs"
                      style="margin-left: 0.5rem;"
                      v-on="on"
                      @click="openLegend"
                    >
                      <v-icon
                        medium
                      >
                        mdi-map-legend
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Mostrar leyenda</span>
                </v-tooltip>

                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      class="mx-2"
                      color="red darken-3"
                      small
                      dark
                      depressed
                      :disabled="isPlaying"
                      fab
                      v-bind="attrs"
                      v-on="on"
                      @click="stopSimulacion"
                    >
                      <v-icon
                        medium
                      >
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar simulación</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row
              dense
              align="center"
            >
              <v-col />
              <v-col
                v-show="simulacion.simulacion.TIPO === 'INCENDIO'"
                align="center"
              >
                <v-btn-toggle
                  v-model="modoSimulacion"
                  color="primary"
                  mandatory
                >
                  <v-tooltip
                    v-for="item in otrasSimulaciones"
                    :key="item.id"
                    bottom
                  >
                    <template
                      #activator="{ on, attrs }"
                    >
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item.nombre }}</span>
                  </v-tooltip>
                </v-btn-toggle>
              </v-col>
              <v-col
                v-show="simulacion.simulacion.TIPO === 'INCENDIO'"
              >
                <v-switch
                  v-show="modoSimulacion === 0"
                  v-model="isocronas"
                  :label="'Isocronas'"
                />
              </v-col>
            </v-row>

            <v-row
              dense
              align="center"
            >
              <v-col
                cols="auto"
              >
                <v-btn
                  v-show="modoSimulacion === 0 || (simulacion.simulacion.VIENTOS)"
                  color="blue darken-3"
                  small
                  dark
                  depressed
                  fab
                  @click="autoPlay"
                >
                  <v-icon
                    medium
                  >
                    {{ isPlaying ? 'mdi-pause' : 'mdi-play' }}
                  </v-icon>
                </v-btn>
              </v-col>

              <v-col>
                <v-slider
                  v-show="modoSimulacion === 0 || (simulacion.simulacion.VIENTOS)"
                  v-model="sliderTime"
                  color="blue darken-3"
                  always-dirty
                  :step="step"
                  :min="min"
                  :max="max"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-slide-y-reverse-transition>
    <SimulacionLegend
      v-if="showLegend"
      v-model="showLegend"
      :modo="modoSimulacion"
      :simulacion="simulacion"
      :modo-color="modoColorVientos"
    />
  </div>
</template>

<script>
import * as ArcGIS from '@/helpers/ArcGIS'
import { mapActions, mapGetters } from 'vuex'
import SimulacionLegend from './SimulacionLegend.vue'
import DateService, { FMT } from '@/helpers/DateService'

export default {

  components: {
    SimulacionLegend
  },
  props: {
    simulacion: { type: Object, required: true }
  },

  data: () => ({
    refreshCounter: 0,
    simulacionSeleccionada: null,
    step: 60, // 60 min
    sliderTime: 0,

    initDate: null,
    date: null,

    superficie: null,

    min: null,
    max: null,

    interval: 0.75,
    isPlaying: false,
    playerTimer: null,

    // Ajustes generales
    otrasSimulaciones: [
      { nombre: 'Simulacion', id: 'simulacion', icon: 'mdi-fire-circle' },
      { nombre: 'Longitud de Llama', id: 'longitudLlama', icon: 'mdi-arrow-up-right' },
      { nombre: 'Intensidad de Llama', id: 'intensidadLlama', icon: 'mdi-chart-bell-curve-cumulative' },
      { nombre: 'Velocidad de Propagación', id: 'velocidadPropagacion', icon: 'mdi-speedometer' }
    ],
    modoSimulacion: 0,
    isocronas: true,
    vientos: true,
    vientosLineas: true,

    showLegend: false,
    modoColorVientos: 'normal',
    colorVientos: {
      normal: {
        minSpeed: '#0010d9',
        medSpeed: '#0080ff',
        maxSpeed: '#00ffff'
      },
      contrast: {
        minSpeed: '#00ff37',
        medSpeed: '#d9ff00',
        maxSpeed: '#ff0000'
      }
    }
  }),

  computed: {
    ...mapGetters('map', [
      'wind3DMode',
      'isMap3D'
    ]),

    modoVientoText() {
      return this.modoColorVientos === 'normal' ? 'Cambiar a modo alto contraste' : 'Cambiar a modo normal'
    },

    dateString() {
      return this.date ? DateService.toString(this.date, FMT.onlyDate) : ''
    },

    timeString() {
      return this.date ? DateService.toString(this.date, FMT.time) : ''
    },

    vientosSwitch: {
      get() {
        return (this.isMap3D && this.wind3DMode === 'lineas')
          ? this.vientosLineas
          : this.vientos
      },
      set(val) {
        if (val) {
          if (this.isMap3D && this.wind3DMode === 'lineas') {
            this.vientosLineas = val
            this.vientos = !val
          } else {
            this.vientos = val
            this.vientosLineas = !val
          }
        } else {
          this.vientos = val
          this.vientosLineas = val
        }

        ArcGIS.updateVientosVisibility(val)
      }
    },

    flechasSwitch: {
      get() {
        return this.wind3DMode !== 'lineas'
      },
      set(val) {
        this.vientos = true
        this.vientosLineas = true
        val ? this.changeWindMode('objetos') : this.changeWindMode('lineas')
      }
    }
  },

  watch: {
    simulacion: {
      handler(newSimulacion) {
        try {
          this.initDate = this.$date.parseDate(newSimulacion.simulacion.FECHA_INICIO)
          this.date = this.$date.parseDate(this.initDate)

          this.step = newSimulacion.simulacion.INTERVALO
          this.min = 0
          this.max = newSimulacion.simulacion.NUM_HORAS * 60

          const simActivaCache = ArcGIS.getSimulacionActivaID()
          this.sliderTime = simActivaCache ? ArcGIS.getSliderTime() : 0

          this.modoSimulacion = newSimulacion.modo ? this.getModoSim(newSimulacion.modo) : 0

          this.simulacionSeleccionada = newSimulacion.simulacion.ID_SIMULACION
          ArcGIS.setSimulacionActivaId(newSimulacion.simulacion.ID_SIMULACION)
          ArcGIS.calcularSuperficie(this.sliderTime)
        } catch (error) {
          console.error('ERROR en simulacion', error)
        }
      },
      immediate: true
    },

    sliderTime(val, oldVal) {
      try {
        if (val !== undefined && val !== null) { // Si val es 0 da false
          if (val > this.max) {
            this.sliderTime = this.min
            this.date = this.$date.parseDate(this.initDate)
            return
          }

          this.date = this.$date.parseDate(this.initDate).add(val, 'minutes')
          this.$emit('updateSimulacionTime', this.sliderTime)
        }
      } catch (error) {
        console.error('ERROR en sliderTime', error)
      }
    },

    modoSimulacion() {
      const data = {
        sim: this.simulacion,
        id: this.otrasSimulaciones[this.modoSimulacion].id
      }

      this.$emit('paintSimulacion', data)
      if (data.id === 'simulacion') {
        this.$emit('updateSimulacionTime', this.sliderTime)
        this.setVisibilityLayer({
          id: `layer-viento-${this.simulacion.simulacion.ID_SIMULACION}`,
          visible: this.vientos
        })
      }
    },

    isocronas() {
      this.setVisibilityLayer({
        id: 'layer-isocronas',
        visible: this.isocronas
      })
    }
  },

  mounted() {
    this.$eventHub.$on('superficieSimulacion', this.updateSuperficieSimulacion)
    this.$eventHub.$on('update-simulaciones-list', () => {
      this.refreshCounter++
    })
  },

  methods: {
    ...mapActions('map', [
      'setVisibilityLayer',
      'setOpacityLayer',
      'setWind3DMode'
    ]),

    openLegend() {
      this.showLegend = !this.showLegend
    },

    autoPlay() {
      this.isPlaying = !this.isPlaying

      if (this.isPlaying) {
        this.playerTimer = setInterval(() => {
          this.sliderTime += this.step
        }, this.interval * 1000)
      } else clearInterval(this.playerTimer)
    },

    stopSimulacion() {
      try {
        this.isPlaying = false
        this.setWind3DMode('lineas')
        clearInterval(this.playerTimer)
        this.$emit('stopSimulacion')

        ArcGIS.setSliderTime(0)
        this.simulacion.componente === 'dialog' ? this.$eventHub.$emit('stopSimulacionesVista') : this.$eventHub.$emit('stopSimulacionesLeftMenu', this.simulacion.idIncendio)
      } catch (error) {
        console.error('ERROR stopSimulacion slider', error)
        this.$notify({ title: 'Error', text: 'No se pudo obtener el incendio.', type: 'error' })
      }
    },

    centerSimulacion() {
      ArcGIS.centerSimulacion(this.simulacion.simulacion.TIPO, this.simulacion.simulacion.ID_SIMULACION)
    },

    updateSuperficieSimulacion(superficie) {
      this.superficie = superficie
    },

    changeWindMode(mode) {
      this.setWind3DMode(mode)
      ArcGIS.updateRendererViento(this.colorVientos[this.modoColorVientos])
    },

    changeVientosColours() {
      this.modoColorVientos = this.modoColorVientos === 'normal' ? 'contrast' : 'normal'
      const coloresAEmitir = this.colorVientos[this.modoColorVientos]

      ArcGIS.updateRendererViento(coloresAEmitir)
    },

    getModoSim(modo) {
      let modoNum
      switch (modo) {
        case 'simulacion':
          modoNum = 0
          break

        case 'longitudLlama':
          modoNum = 1
          break

        case 'intensidadLlama':
          modoNum = 2
          break

        case 'velocidadPropagacion':
          modoNum = 3
          break
      }

      return modoNum
    }
  }
}
</script>

<style scoped>
#mapSlider {
  opacity: 0.8;
  transition: 0.5s;
  border-radius: 0.5rem;
  z-index: 1;
  position: absolute;
  bottom: 5%;
  width: 650px;
  left: 50%;
  margin-left: -300px;
}

#mapSlider:hover {
  transition: 0.5s;
  opacity: 1;
}

#timer {
  font-size: 24px;
  line-height: 1;
}

#fecha,
#superficie {
  font-size: 14px;
}

.ml-1 {
  margin-left: 4px !important;
}

#slider {
  width: 80%;
}

.slider-wrapper {
  display: flex;
}

@media screen and (min-width: 1024px) {
  #mapSlider {
    bottom: 5%;
    width: 650px;
    left: 50%;
    margin-left: -300px;
  }
}

@media screen and (min-width : 431px) and (max-width : 1023px) {
  #mapSlider {
    bottom: 5%;
    width: 90%;
    left: 5%;
    margin-left: 0;
  }
}

@media screen and (min-width : 0px) and (max-width : 430px) {
  #mapSlider {
    bottom: 2%;
    left: 5%;
    width: 90%;
    margin-left: 0;
  }

  #timer {
    font-size: 18px;
  }
}
</style>
